<template>
  <div>
    <common-dialog
      ref="dialog"
      width="850px"
      line-form
      unit="模具档案"
      form-label-width="105px"
      edit-title
      id-key="Id"
      @opened="onOpened"
      :data="data"
      @create-opened="onCreateOpened"
      @edit-opened="onEditOpened"
      :form-rules="rules"
      :save-func="api.save"
      :before-save="onBeforeSave"
      @closed="toClosed"
      @close-saved="$emit('close-saved')"
    >
      <template slot="form">
        <el-row>
          <el-col :span="12">
            <el-form-item label="模具编码" prop="mjbm">
              <el-input v-model="data.mjbm" placeholder="请输入模具编码"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="模具类别" prop="ClassId">
              <tree-select
                ref="treeSelect"
                :props="props"
                :options="TreeData"
                :value="data.ClassId"
                :clearable="false"
                :accordion="true"
                :parentSelect="true"
                placeholder="请选择"
                @node-select="onTreeSelect($event)"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="类型" prop="lx">
              <el-select v-model="data.lx">
                <el-option :value="0" label="公模"></el-option>
                <el-option :value="1" label="私模"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="总腔数" prop="zqs">
              <el-input type="number" v-int v-model="data.zqs" placeholder="请输入总腔数"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="总款数" prop="zks">
              <el-input type="number" v-int v-model="data.zks" placeholder="请输入总款数"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="材质" prop="cz">
              <el-input type="text" v-model="data.cz" placeholder="请输入材质"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="周期" prop="zq">
              <el-input type="number" v-model="data.zq" placeholder="请输入周期"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="水口重" prop="skz">
              <el-input type="number" v-model="data.skz" placeholder="请输入水口重"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="内腔规格" prop="nqgg">
              <el-input type="text" v-model="data.nqgg" placeholder="请输入内腔规格"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="适用机台型号" prop="syjtxh">
              <el-select v-model="data.syjtxh" placeholder="请输入适用机台型号">
                
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="客户名称" prop="khmc">
              <el-input type="text" v-model="data.khmc" placeholder="请输入客户名称"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="当前状态" prop="Status">
              <el-select v-model="data.Status">
                <el-option :value="0" label="在库"></el-option>
                <el-option :value="1" label="生产归还"></el-option>
                <el-option :value="2" label="归还客户"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="备注" prop="Remark">
              <el-input type="text" v-model="data.Remark" placeholder="请输入备注"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-tabs v-model="activeName">
          <el-tab-pane label="配件信息" name="tab1">
            <el-table :data="Pus" ref="tableList" border>
              <el-table-column prop="pjmc" label="配件名称" min-width="110" align="center">
                <template slot-scope="{ row }">
                  <el-input v-model="row.pjmc" placeholder="请选择配件信息"></el-input>
                </template>
              </el-table-column>
              <el-table-column prop="pjbm" label="配件编码" min-width="110" align="center" />
              <el-table-column prop="qs" label="腔数" min-width="110" align="center">
                <template slot-scope="{ row }">
                  <el-input type="number" v-model="row.qs" placeholder="请输入腔数"></el-input>
                </template>
              </el-table-column>
              <el-table-column prop="dz" label="单重" min-width="110" align="center">
                <template slot-scope="{ row }">
                  <el-input type="number" v-model="row.dz" placeholder="请输入单重"></el-input>
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
          <el-tab-pane label="工艺参数" name="tab2">
            <el-table :data="ProductData" ref="tableList" border>
              <el-table-column prop="CreateTime" label="时间" min-width="110" align="center"> </el-table-column>
              <el-table-column prop="WorkDocNo" label="注塑工单" min-width="110" align="center"> </el-table-column>
              <el-table-column prop="CraftRecType" label="类型" min-width="110" align="center">
                <template slot-scope="{ row }">
                  <span v-if="row.CraftRecType == 0">最大模数</span>
                  <span v-if="row.CraftRecType == 1">最新</span>
                </template>
              </el-table-column>
              <el-table-column label="详细数据" min-width="110" align="center">
                <template slot-scope="{ row }">
                  <el-button type="success" @click="showDetail(row)">查看</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
        </el-tabs>
      </template>
      <template slot="footer">
        <el-button type="primary" @click="toSave">保存</el-button>
        <el-button @click.stop="close">关 闭</el-button>
      </template>
    </common-dialog>
    
    <edit-dialog ref="editDialog" @close-saved="reload"></edit-dialog>
  </div>
</template>
<script>
import editDialogMixin from '@/mixins/editDialog'
import commonDialog from '@/components/common/dialog'
import typeSelect from './type/select'

import mouldSelect from './select'
import wmsSelect from '@/components/basedata/basedoc/wms/select'
import treeSelect from '@/components/common/treeSelect'
import productSelect from '@/components/basedata/inventory/archives/select'
import unitSelect from '@/components/basedata/inventory/unit/select'
import editDialog from '@/components/facility/equipment/craftdata/editDialog'

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
    typeSelect,
    mouldSelect,
    wmsSelect,
    treeSelect,
    productSelect,
    unitSelect,
    editDialog
  },
  data() {
    return {
      data: {
        Id: 0,
        mjbm: "",
        mjlb: "",
        lx: null,
        zqs: null,
        zks: null,
        cz: "",
        zq: "",
        skz: "",
        nqgg: "",
        syjtxh: "",
        khmc: "",
        ClassId: null,
        ClassName: "",
        Status: null
      },
      unitApi: require('@/api/ba/unit').default,
      code_api: require('@/api/sy/serialCode').default,
      api: require('@/api/ba/mould').default,
      classApi: require('@/api/ba/class').default,
      productApi: require('@/api/ba/product').default,
      // 默认供应商
      tradeUnitApi: require('@/api/ba/tradeUnit').default,
      equipmentApi: require('@/api/ba/equipment').default,
      craftsumApi: require('@/api/equipment/craftsum').default,
      TreeData: [],
      productList: [],
      props: {
        value: 'ClassId',
        label: 'ClassName',
        children: 'children'
      },
      unitParams: {
        UnitGroupId: null,
        IsGroup: false
      },
      unitList: [], // 单位列表
      tradeUnitList: [],
      tradeUnitValueList: [], //构造有value值的供应商列表
      equipmentList: [], // 设备列表
      equipmentValueList: [], // 构造有value值的设备列表
      activeName: 'tab1', // 当前页签，默认基础信息
      unitId: null,
      unitName: '',
      isWeight: false,
      rules: {
        // mjbm: [{ required: true, message: '模具编码不能为空' }],
        // ClassId: [{ required: true, message: '模具类别不能为空' }],
        // MouldNature: [{ required: true, message: '生产类型不能为空' }],
        // Status: [{ required: true, message: '状态不能为空' }]
      },
      Pus: [
        { pjbm: "", pjmc: "", dz: null, qs: null }
      ],
      ProductData: []
    }
  },
  computed: {},
  methods: {
    showDetail(row){
      this.$refs.editDialog.openDetails(row);
    },
    onOpened() {
      // this.getProductData()
    },
    onCreateOpened(data) {
      // this.classApi.list({ ClassType: 13 }).then(res => {
      //   this.TreeData = this.$commonJs.toTreeData(res.Data, 'ClassId')
      //   if (data.ClassId > 0) {
      //     this.$refs.treeSelect.setData(data.ClassId)
      //   }
      // })
      // this.api.getMaxSn().then(res => {
      //   this.data.Sn = res
      // })
    },
    onEditOpened(data) {
      // this.api.info(data.MouldId).then(res => {
      //   this.data = res.Data
      //   this.Pus = res.Data.Rubbers.map(item => ((item.T = 3), item))

      //   let length = this.Pus.length
      //   let sum = 0
      //   for (let i = 0; i < length; ++i) {
      //     sum = sum + this.Pus[i].Weight * this.Pus[i].Quantity
      //   }
      //   this.data.PerNetWeight = parseFloat(sum.toFixed(2))

      //   this.data.PerNetWeightUnitId = this.data.PerNetWeightUnitId ?? this.data.PerGrossWeightUnitId
      //   this.data.PerNetWeightUnitName = this.data.PerNetWeightUnitName ?? this.data.PerGrossWeightUnitName
      //   this.data.ReplaceMouldId = this.data.ReplaceMouldId !== 0 ? this.data.ReplaceMouldId : null
      //   this.data.Price = this.data.Price !== 0 ? this.data.Price : null

      //   this.getTreeData()
      // })
    },
    onTreeSelect(t) {
      if (!t) {
        this.data.ClassName = ''
        this.data.ClassId = null
      } else {
        this.data.ClassName = t.ClassName
        this.data.ClassId = t.ClassId
        this.data.IdChain = t.IdChain
      }
    },
    // 加工商选择，将id赋值到默认供应商里
    changeConverter(val) {
      let id = this.tradeUnitList.filter(item => item.FullName === val)[0]?.TradeUnitId
      if (id) {
        this.data.DefaultSupplier = id
      } else {
        this.data.DefaultSupplier = 0
      }
    },
    getProductData() {
      this.productApi.productList({ ProductType: 2 }).then(res => {
        this.productList = res.Data
      })

      this.unitApi.list({ UnitGroupId: null, IsGroup: false, Status: 1 }).then(res => {
        if (res.Code === 0) {
          this.unitList = res.Data

          let list = res.Data.filter(item => {
            return item.UnitName === '克'
          })

          console.log('list', list)

          if (list == null || list.length === 0) {
            this.$message.warning('请先在计量单位创建单计量单位克')

            return
          } else {
            let item = list[0]

            this.unitId = item.UnitId
            this.unitName = item.UnitName

            if (this.data.Weight) {
              this.data.WeightUnitId = item.UnitId
              this.data.WeightUnitName = item.UnitName
            }

            this.data.PerGrossWeightUnitId = item.UnitId
            this.data.PerGrossWeightUnitName = item.UnitName

            this.data.PerNetWeightUnitId = item.UnitId
            this.data.PerNetWeightUnitName = item.UnitName
          }

          // PerGrossWeightUnitId WeightUnitId PerNetWeightUnitId
        }
      })

      this.tradeUnitApi.list({ TradeUnitTypes: [1, 3] }).then(res => {
        this.tradeUnitList = res.Data

        this.tradeUnitValueList = res.Data.map(item => {
          return {
            value: item.FullName,
            ...item
          }
        })
        // console.log("默认供应商");
        // console.log(this.tradeUnitList);
      })

      this.equipmentApi.list({ Statuses: [1, 2] }).then(res => {
        this.equipmentList = res.Data
        this.equipmentValueList = res.Data.map(item => {
          return {
            value: item.EquipmentName,
            ...item
          }
        })
      })
    },
    getTreeData() {
      this.classApi.list({ ClassType: 13 }).then(res => {
        this.TreeData = this.$commonJs.toTreeData(res.Data, 'ClassId')
        if (this.data.ClassId > 0) {
          this.$refs.treeSelect.setData(this.data.ClassId)
        }
      })
    },
    // mouldChange(data, index) {
    //   console.log('pus', this.Pus)
    //   console.log('data', data)
    //   let ids = this.Pus.map(i => i.ProductId)
    //   if (ids.includes(data.ProductId)) this.$message.warning('列表中已存在相关产品')
    //   // this.$refs.tableList.data[index].ProductNo = data.ProductNo
    //   // this.$refs.tableList.data[index].ProductId = data.ProductId
    //   this.Pus[index].ProductNo = !ids.includes(data.ProductId) ? data.ProductNo : null
    //   this.Pus[index].ProductId = !ids.includes(data.ProductId) ? data.ProductId : null
    //   this.Pus[index].ProductName = !ids.includes(data.ProductId) ? data.ProductName : null
    //   this.changT(data, index)
    // },
    // changT(data, index) {
    //   if (this.Pus[index].T === 3) this.Pus[index].T = 1
    // },
    // onBeforeSave() {
    //   this.Pus = this.Pus.filter((i) => i.ProductId !== null);
    //   console.log("Pus", this.Pus);
    //   if (this.data.Rubbers.length == 0) {
    //     this.data.Rubbers = this.$refs.tableList.data.map(
    //       (item) => ((item.T = 0), item)
    //     );
    //   } else {
    //     let delIds = this.Pus.map((item) => item.ProductId);
    //     let delList = this.data.Rubbers.reduce((arr, item) => {
    //       if (!delIds.includes(item.ProductId)) arr.push({ ...item, T: 2 });
    //       return arr;
    //     }, []);

    //     let addIds = this.data.Rubbers.map((item) => item.ProductId);
    //     let addList = [];
    //     addList = this.Pus.reduce((arr, item) => {
    //       if (!addIds.includes(item.ProductId)) arr.push({ ...item, T: 0 });
    //       return arr;
    //     }, []);
    //     let updateList = this.Pus.filter((i) => i.T == 1);
    //     this.data.Rubbers = [...addList, ...delList, ...updateList];
    //   }
    // },
    onBeforeSave() {

    },
    toClosed() {
      this.Pus = []
      this.TreeData = []
      this.productList = []
      this.$refs.treeSelect.clearHandle()
      Object.assign(this.$data, this.$options.data())
    },
    toSave() {
      return false;
    },
    // doSave() {
    //   let data = this.$commonJs.obj.removeNullKey(this.data)
    //   this.api.save(data).then(res => {
    //     if (res.Code == 0) {
    //       this.$message.success(res.Msg)
    //       this.$emit('close-saved')
    //       this.close(true)
    //     } else {
    //       this.$message.error(res.Msg)
    //     }
    //   })
    // }
  }
}
</script>
